module.exports = __webpack_public_path__ + "static/media/3.38483133.jpg";